<template>
  <div class="mobile-share-center">
    <div class="mobile-share-header">
      <h2 class="m-page-title">我的分享</h2>
      <span class="m-sub-title">管理你已分享给好友的合集内容</span>
    </div>

    <div
      v-infinite-scroll="loadMore"
      class="mobile-share-wrapper"
      :infinite-scroll-disabled="infiniteDisabled"
      infinite-scroll-distance="30"
    >
      <div class="share-card-list">
        <div
          v-for="item in dataList"
          :key="item.shareId"
          class="share-item-card"
        >
          <div class="card-main-row">
            <div class="album-title-box">
              <i class="el-icon-folder-opened m-album-icon" />
              <span class="m-album-name">{{ item.albumName }}</span>
            </div>
            <el-tag :type="getTagType(item.albumType)" size="mini" effect="light" round>
              {{ item.albumType }}
            </el-tag>
          </div>

          <div class="card-meta-block">
            <div class="meta-line">
              <i class="el-icon-time" />
              <span>分享于: {{ item.shareAt }}</span>
            </div>
            <div class="meta-line" @click="getShareToList(item)">
              <i class="el-icon-user" />
              <span>被分享人: <strong class="danger-highlight">{{ item.num }} 位用户</strong></span>
              <i class="el-icon-arrow-right view-arrow-inline" />
            </div>
          </div>

          <el-divider class="card-inner-divider" />

          <div class="card-action-bar">
            <el-button
              size="small"
              type="danger"
              plain
              round
              icon="el-icon-share"
              class="m-action-btn"
              @click="deleteShare(item)"
            >
              取消分享
            </el-button>
          </div>
        </div>
      </div>

      <div class="load-status">
        <p v-if="loading"><i class="el-icon-loading" /> 正在加载中...</p>
        <p v-if="noMore && dataList.length > 0">已加载所有分享</p>
        <el-empty v-if="dataList.length === 0 && !loading" :image-size="80" description="暂无任何分享" />
      </div>
    </div>

    <el-dialog
      title="分享名单"
      :visible.sync="showShareToDialog"
      width="88%"
      custom-class="mobile-share-dialog"
      append-to-body
    >
      <div class="m-share-user-list">
        <div v-if="shareToList.length === 0" class="m-empty-list">暂无分享用户</div>
        <div v-for="(user, index) in shareToList" :key="index" class="m-user-item">
          <div class="u-info-left">
            <el-avatar :size="32" icon="el-icon-user" class="u-avatar" />
            <span class="u-name">{{ user.username }}</span>
          </div>
          <el-tag size="mini" type="success" plain>已查看</el-tag>
        </div>
      </div>
      <div slot="footer" class="m-popup-footer">
        <el-button type="primary" round style="width: 100%" @click="showShareToDialog = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deleteShare, getShareList, getShareToList } from '@/api/disk'

export default {
  name: 'DiskShareMobile',
  data() {
    return {
      currentPage: 1,
      dataList: [],
      loading: false,
      noMore: false,
      showShareToDialog: false,
      shareToList: []
    }
  },
  computed: {
    infiniteDisabled() {
      return this.loading || this.noMore
    }
  },
  created() {
    // 初始由 infinite-scroll 自动触发首屏加载
  },
  methods: {
    loadMore() {
      if (this.infiniteDisabled) return
      this.loading = true

      getShareList(this.currentPage).then(resp => {
        if (resp.code === 0) {
          const { list, totalSize } = resp.data
          // 增量追加列表
          this.dataList = [...this.dataList, ...list]

          // 如果列表长度达到总数，停止滚动加载
          if (this.dataList.length >= totalSize || list.length === 0) {
            this.noMore = true
          } else {
            this.currentPage++
          }
        } else {
          this.noMore = true
          this.$message.error(resp.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getTagType(type) {
      const map = { '视频': 'danger', '图片': 'success', '文档': 'warning' }
      return map[type] || 'info'
    },
    getShareToList(row) {
      getShareToList(row.shareId).then(resp => {
        if (resp.code === 0) {
          this.shareToList = resp.data
          this.showShareToDialog = true
        }
      })
    },
    deleteShare(row) {
      this.$confirm(`确定要取消针对合集 "${row.albumName}" 的分享吗？`, '取消分享', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
        width: '85%', // 限制确认框宽度适配手机
        roundButton: true
      }).then(() => {
        deleteShare(row.shareId).then(resp => {
          if (resp.code === 0) {
            this.$message.success('已取消分享')
            // 重置状态、局部重载
            this.currentPage = 1
            this.dataList = []
            this.noMore = false
            this.loadMore()
          } else {
            this.$message.error(resp.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.mobile-share-center {
  background-color: #f6f8fa;
  min-height: 100vh;
}

/* 顶部文案区 */
.mobile-share-header {
  padding: 16px 14px 4px 14px;
}
.m-page-title {
  font-size: 18px;
  font-weight: bold;
  color: #0f172a;
  margin: 0;
}
.m-sub-title {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
  display: block;
}

/* 独立流卡片容器 */
.mobile-share-wrapper {
  padding: 10px 12px 60px 12px;
}
.share-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 分享单体卡片设计 */
.share-item-card {
  background: #fff;
  border-radius: 14px;
  padding: 14px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.01);
}

.card-main-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}
.album-title-box {
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
}
.m-album-icon {
  font-size: 20px;
  color: #f59e0b;
  flex-shrink: 0;
}
.m-album-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 元数据组：垂直列表 */
.card-meta-block {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.meta-line {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #64748b;
  -webkit-tap-highlight-color: transparent;
}
.meta-line:active {
  color: #1a73e8; /* 点击时给被分享人一栏反馈 */
}
.meta-line i {
  font-size: 14px;
  color: #94a3b8;
}
.danger-highlight {
  color: #ef4444;
  font-weight: 600;
}
.view-arrow-inline {
  font-size: 11px !important;
  margin-left: auto; /* 将小箭头右推 */
  color: #cbd5e1 !important;
}

.card-inner-divider {
  margin: 12px 0 10px 0 !important;
}

/* 底部功能区 */
.card-action-bar {
  display: flex;
  justify-content: flex-end;
}
.m-action-btn {
  font-weight: 500;
  padding: 6px 14px;
}

/* 无限加载提示 */
.load-status {
  text-align: center;
  padding: 20px 0;
  font-size: 12px;
  color: #94a3b8;
}

/* 分享名单弹窗优化 */
::v-deep .mobile-share-dialog {
  border-radius: 16px !important;
}
::v-deep .mobile-share-dialog .el-dialog__body {
  padding: 10px 16px 20px 16px;
}
.m-share-user-list {
  max-height: 240px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.m-user-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}
.m-user-item:not(:last-child) {
  border-bottom: 1px solid #f1f5f9;
}
.u-info-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.u-name {
  font-size: 13px;
  color: #334155;
  font-weight: 500;
}
.m-empty-list {
  text-align: center;
  padding: 24px;
  color: #94a3b8;
  font-size: 13px;
}
.m-popup-footer {
  padding-top: 4px;
}
</style>
